import type { SieveProjectStatus } from '@/types';

/**
 * Klasa pigułki dla statusu analizy sitowej.
 *
 * NIE składaj tej klasy z `statusColor` zwracanego przez backend: enum SieveProjectStatus podaje
 * „gray" / „blue" / „green", a w index.css nie ma `pill-blue` — status ACTIVE (najczęstszy)
 * wyszedłby wtedy bez stylu. Mapowanie trzymamy w jednym miejscu, bo lista modułu i karta ujęcia
 * muszą pokazywać ten sam status tak samo.
 */
export const SIEVE_STATUS_PILL: Record<SieveProjectStatus, string> = {
  DRAFT: 'pill-gray',
  ACTIVE: 'pill-water',
  DONE: 'pill-green',
};

/** Bezpieczny fallback dla statusu spoza enuma (np. po rozszerzeniu backendu). */
export function sieveStatusPill(status?: SieveProjectStatus | null): string {
  return (status && SIEVE_STATUS_PILL[status]) || 'pill-gray';
}
